import MyRouter from "./router";
import UpdateBanner from "./components/UpdateBanner";

function App() {
  return (
    <>
      <UpdateBanner />
      <MyRouter />
    </>
  );
}

export default App;
